import { render } from "./BuilderBase.vue?vue&type=template&id=2605dbde"
import script from "./BuilderBase.vue?vue&type=script&lang=js"
export * from "./BuilderBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__